var installedModules = {};
var moduleToHandlerMapping = {
	33063: {
		getter: () => (__webpack_require__.e(7810).then(() => (() => (__webpack_require__(77810))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	67533: {
		getter: () => (Promise.all([__webpack_require__.e(140), __webpack_require__.e(4374)]).then(() => (() => (__webpack_require__(22483))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	66951: {
		getter: () => (Promise.all([__webpack_require__.e(3488), __webpack_require__.e(4067)]).then(() => (() => (__webpack_require__(88581))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.11",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	71755: {
		getter: () => (Promise.all([__webpack_require__.e(6878), __webpack_require__.e(1391), __webpack_require__.e(5772)]).then(() => (() => (__webpack_require__(81342))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.22.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"3063": [
		33063
	],
	"4975": [
		66951,
		71755
	],
	"7533": [
		67533
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({chunkMapping, installedModules, chunkId, moduleToHandlerMapping, promises, webpackRequire:__webpack_require__});
}